import type { ReactNode } from 'react';

/**
 * The wrapper for the screens that render without the rail: sign-in, the
 * sign-in failures, and the two bootstrap states before an org resolves.
 *
 * The product has no name of its own yet. The company is Arbiter, so these
 * screens — the only ones with no rail to say where you are — carry "Arbiter
 * Network Intelligence" as their headline, and the state's own line reads under
 * it as the secondary.
 */
export function BareState({ children }: { children: ReactNode }) {
  return (
    <div className="page-state bare">
      <div className="bare-mark">Arbiter Network Intelligence</div>
      {children}
    </div>
  );
}
